/**
 * File Base to Actions to map layer control
 * @author: adalto.junior
 * Date: 09/12/13
 * Time: 17:36
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

Greenmile.Toolbar.MapLayerActions.Base = function () {

    this.NAME_KEY = 'layerMap';
    this.RESOURCE_LAYER = 'Greenmile.Toolbar.baseLayer';

    this.map = null;

    this.events = {};
    this.routeId = null;

    this.setEvent = function (eventKey, fn) {
        this.events[eventKey] = fn;
    };

    this.setRouteId = (routeId) => {
        this.routeId = routeId;
    }

    /*
     * fix pra versao 4.6 pra corrigir o nome da camada de stops
     *
     */
    var adjustNameLayerStops = function (context) {

        return function (mapLayerObj) {

            if (mapLayerObj.hasOwnProperty('routes')) {

                var status = mapLayerObj.routes;

                delete mapLayerObj.routes;

                mapLayerObj[context.LAYER_NAME] = status;

                Monet.Session.sessionStorage.setItem(context.NAME_KEY, JSON.stringify(mapLayerObj));
                new Greenmile.Storage.StoreMapPosition().setLayerMapFromUser(mapLayerObj);

            }

        };
    }(this);

    this.fireEvent = function (eventKey, args) {
        var fn = this.events[eventKey];
        if (fn) {
            fn.call(this, args);
        }
    };

    this.getLayerStatusOnLocalStorage = function () {

        var localStorageText = Monet.Session.sessionStorage.getItem(this.NAME_KEY);
        var status = false;
        var mapLayerObj;

        if (localStorageText) {

            mapLayerObj = JSON.parse(localStorageText);

            if (Monet.Session.sessionStorage.GMLocalStorageVersion !== App.Version.GMLBuildNumber) {
                adjustNameLayerStops(mapLayerObj);
            }

            if (mapLayerObj[this.LAYER_NAME]) {

                status = true;

            }

        }

        return status;

    };

    this.setLayerStatusOnLocalStorageByTagName = function (status) {

        var localStorageText = Monet.Session.sessionStorage.getItem(this.NAME_KEY);
        var mapLayerObj = {};

        if (localStorageText) {

            mapLayerObj = JSON.parse(localStorageText);

        }

        mapLayerObj[this.LAYER_NAME] = status;

        new Greenmile.Storage.StoreMapPosition().setLayerMapFromUser(mapLayerObj);

    };

    this.afterClickOnCheckBox = function () {
        console.log('your class need implements this method');
    };

    this.render = function () {
        
      const itemList = document.createElement('li');
      const divLabel = document.createElement('div');
      const divCheckBox = document.createElement('div');
      const label = document.createElement('label');
      const layerIsChecked = this.getLayerStatusOnLocalStorage();
      const referenceRoute = this.map.routeId ? `-route-${this.map.routeId}` : '';

      this.checkBox = document.createElement('input');
      this.checkBox.id = `${this.LAYER_NAME}${referenceRoute}`;
      this.checkBox.name = this.LAYER_NAME;
      this.checkBox.type = 'checkbox';
      this.checkBox.removeEventListener('click', this.afterClickOnCheckBox);
      this.checkBox.addEventListener('click', this.afterClickOnCheckBox.bind(this));

      divCheckBox.className = 'radio';
      divCheckBox.appendChild(this.checkBox);

      label.setAttribute('for', `${this.LAYER_NAME}${referenceRoute}`);
      label.innerHTML = Monet.I18n.getResourcesByKey(this.RESOURCE_LAYER);

      divLabel.className = 'text';
      divLabel.appendChild(label);

      if (this.className) {
          divLabel.className = this.className;
      }

      itemList.appendChild(divCheckBox);
      itemList.appendChild(divLabel);

      if (layerIsChecked) {
          this.checkBox.checked = 'checked';
      }

      return itemList;
    };
};

/**
 * Enum que contêm as camadas do mapa, para facilitar a nomenclatura e manutenção.
 * @type {{STOPS: string, ACTUAL_ROUTE: string, PLANNED_ROUTE: string, BASELINE_PLANNED_ROUTE: string, EVENT_ROUTE: string, RADIUS_ROUTE: string, PENDING_ORDERS: string}}
 */
Greenmile.Toolbar.MapLayers = {
    STOPS: 'layerStops',
    ACTUAL_ROUTE: 'layerActualRoute',
    PLANNED_ROUTE: 'layerPlannedRoute',
    BASELINE_PLANNED_ROUTE: 'layerBaselinePlannedRoute',
    EVENT_ROUTE: 'layerEventRoute',
    EVENT_EQUIPMENT: 'layerEventEquipment',
    RADIUS_ROUTE: 'layerRadiusRoute',
    EXPANDED_RADUIS: 'layerExpandedRadiusStop',
    PENDING_ORDERS: 'layerPendingOrders',
    MULTI_ROUTE: 'layerActualRouteWithMultiRoute',
    SIGNATURES: 'layerSignatures',
    ARRIVAL: 'layerArrival',
    DEPARTURE: 'layerDeparture'
};

